'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactReduxForm = require('react-redux-form');

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _qs = require('qs');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _forms = require('common/components/forms');

require('./recover-password-form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FORM_NAME = 'recoverPassword';

var supportEmail = _hfReactHelper2['default'].HfConstants.supportEmail[_hfReactHelper2['default'].HfSites.SITE_CODE_HS];
var mailToLink = _react2['default'].createElement(
    'a',
    { href: 'mailto:' + supportEmail + '?subject=' + encodeURIComponent('Password Reset') },
    supportEmail
);

/**
 * Confirmation message, displayed after the form is submitted
 */
function RecoveryMessage() {
    return _react2['default'].createElement(
        'div',
        { className: 'row text-center', 'data-test-ref': 'recovery-message' },
        _react2['default'].createElement(
            'div',
            { className: 'columns small-12' },
            _react2['default'].createElement(
                'h2',
                null,
                'Check your inbox'
            ),
            _react2['default'].createElement(
                'span',
                null,
                _react2['default'].createElement(
                    'p',
                    { className: 'l-400' },
                    'If that is a valid address, we have sent an email to it to reset your password.'
                ),
                _react2['default'].createElement('hr', { className: 'm-recover-password-form--rule' }),
                _react2['default'].createElement(
                    'p',
                    { className: 'l-400' },
                    'If you\'re still experiencing difficulties, please contact us at\xA0',
                    mailToLink,
                    '.'
                )
            )
        )
    );
}

/**
 * Recover Password Form
 *
 * Allows a user to submit an email address for a password reset, then shows a confirmation message.
 */

var RecoverPasswordForm = function (_React$Component) {
    _inherits(RecoverPasswordForm, _React$Component);

    function RecoverPasswordForm(props) {
        _classCallCheck(this, RecoverPasswordForm);

        // Pre-bind custom methods
        var _this = _possibleConstructorReturn(this, (RecoverPasswordForm.__proto__ || Object.getPrototypeOf(RecoverPasswordForm)).call(this, props));

        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
        _this.handleResponse = _this.handleResponse.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    /**
     * Handle any generic/fallback errors
     */


    _createClass(RecoverPasswordForm, [{
        key: 'handleGeneralError',
        value: function handleGeneralError(error) {
            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));

            // Display error message
            this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
                server: 'derp'
            }));
        }

        /**
         * Handles the response from the server after submitting the form
         */

    }, {
        key: 'handleResponse',
        value: function handleResponse(err, response) {
            // Error here means some kind of network error (4xx or 5xx)
            if (err) {
                return this.handleGeneralError(err);
            }

            try {
                // Here we can get errors back from the server and display errors if necessary
                // (This particular form never returns anything useful, so just proceed to the confirmation message now)
                this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));
            } catch (e) {
                return this.handleGeneralError(err);
            }
        }

        /**
         * This handler is called _after_ react-redux-form has validated the form.
         */

    }, {
        key: 'handleSubmit',
        value: function handleSubmit(values) {
            var _this2 = this;

            // Prepare POST payload
            var url = _hfReactHelper2['default'].urlHelper('account/recoverPassword', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
            var data = (0, _qs.stringify)({
                recover: {
                    email_address: values.email,
                    _csrf_token: values.csrfToken
                }
            });

            // Submit the POST
            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
            }).end(this.handleResponse);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$form$$form = this.props.form['$form'],
                submitted = _props$form$$form.submitted,
                submitting = _props$form$$form.pending;

            return _react2['default'].createElement(
                'div',
                { className: 'm-recover-password-form' },
                !submitted && _react2['default'].createElement(
                    'div',
                    { 'data-test-ref': 'form-div' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'l-text-centered' },
                        _react2['default'].createElement(
                            'h2',
                            null,
                            'Reset password'
                        ),
                        _react2['default'].createElement(
                            'p',
                            { className: 'l-400' },
                            'Please enter your email address to request a password reset.'
                        )
                    ),
                    _react2['default'].createElement('hr', { className: 'm-recover-password-form--rule' }),
                    _react2['default'].createElement(
                        _reactReduxForm.Form,
                        {
                            model: FORM_NAME,
                            onSubmit: this.handleSubmit,
                            'data-test-ref': 'form' },
                        _react2['default'].createElement(
                            _forms.Field,
                            { label: 'Email Address' },
                            _react2['default'].createElement(_reactReduxForm.Control.input, {
                                type: 'email',
                                model: 'recoverPassword.email',
                                validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
                            }),
                            _react2['default'].createElement(_reactReduxForm.Errors, {
                                model: 'recoverPassword.email',
                                show: 'touched',
                                messages: { isEmail: 'Please enter a valid email address' },
                                className: 'm-field--error',
                                'data-test-ref': 'email-input-errors'
                            })
                        ),
                        _react2['default'].createElement(_button2['default'], {
                            buttonText: 'Reset Password',
                            buttonColor: 'azure',
                            buttonClass: 'm-recover-password-form--button',
                            type: 'submit',
                            disabled: submitting
                        }),
                        _react2['default'].createElement(_reactReduxForm.Errors, {
                            model: FORM_NAME,
                            show: true,
                            className: 'c-blood'
                        })
                    )
                ),
                submitted && _react2['default'].createElement(RecoveryMessage, null)
            );
        }
    }]);

    return RecoverPasswordForm;
}(_react2['default'].Component);

// This mapping is used by connect to expose (as props) parts of state that we need in this component


RecoverPasswordForm.propTypes = {
    // React Redux Form object, provided from Redux state by connect
    form: _react2['default'].PropTypes.object.isRequired,

    // Redux dispatcher object, provided from Redux by connect
    dispatch: _react2['default'].PropTypes.func.isRequired
};
function mapStateToProps(state) {
    return {
        form: state.forms.recoverPassword
    };
}

// Export as default the connected form
exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(RecoverPasswordForm);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/recover-password-form.jsx
 ** module id = 1013
 ** module chunks = 0
 **/